import { useEffect } from "react";
import { Router } from "@reach/router";
import { connect } from "react-redux";
import Skeleton from "react-loading-skeleton";
import { ContentContainer } from "../components/Layout";
import { AppMenu } from "newui/features/AppMenu";
import {
	getDocuments,
	getPastProjects,
	getResources,
} from "actions/companyActions";
//Routes
import { MyAccount } from "../routes/account/MyAccount";
import { Breadcrumbs } from "components/Breadcrumb";

import { NotFound } from "newui/features/ErrorPages/NotFound";
import { RfxSettings, Settings } from "newui/features/Settings";
import { AddProject } from "components/ProjectForm/AddProject";
import { EditProject } from "components/ProjectForm/EditProject";
import { DocumentRequest } from "components/DocumentRequest";
import { UpdateCreditCard } from "components/CreditCardDetail";
import { CreateUserForm } from "components/UserProfile";

import { useProfileContext } from "newui/features/Auth/context/ProfileContext";
import RfqOverview from "pages/SupplierFlow/RfqOverviews/RfqOverviews";
import { Search } from "./search/Search";
import { Invoice } from "components/Invoice";
import { EditUserAccount } from "components/EditUserAccount";
import { Box } from "@chakra-ui/react";
import RFQPreview from "newui/features/Rfx/Submission/RFQPreview";
import { RfxSubmissionDataProvider } from "newui/features/Rfx/data-provider/RfxSubmissionDataProvider";
import GetRfxSubmissionByCompany from "app/GetRfxSubmissionByCompany";
import { useCurrentCompany } from "hooks/auth";
import { CompanyProfile } from "newui/features/Company";
import { KeyPersonnelFormPage } from "newui/features/Company/KeyPersonnel";
import { EditUserProfile } from "components/EditUserProfile";

export const SupplierComponent = ({
	getPastProjects,
	getResources,
	getDocuments,
	loading,
	path, // eslint-disable-line no-unused-vars
}) => {
	const profileContext = useProfileContext();
	const currentCompany = useCurrentCompany();
	useEffect(() => {
		//Set this company ID from the route variable - this allows anyone to access/edit all companies
		//When auth system is implemented, the getCompany action will be dispatched during login action,
		//and this data will be ready in the store

		const companyId = currentCompany?.id;

		if (companyId) {
			getPastProjects(companyId);
			getResources(companyId);
			getDocuments(companyId);
		}
	}, [currentCompany, getPastProjects, getDocuments, getResources]);

	return (
		<>
			{!loading ? (
				<Box
					display="flex"
					flexWrap="nowrap"
					width="100%"
					minH="100vh"
				>
					<AppMenu />

					<ContentContainer
						id="element-scroll"
						className="px-1.5"
					>
						<Breadcrumbs ignoreCompany={false} />
						<Router primary={false}>
							<MyAccount path="my-account" />

							{/* <CompanyProfile path="company-profile/*" company={company} /> */}
							{profileContext?.isRfqFeatureEnabled && (
								<>
									<GetRfxSubmissionByCompany
										companyId={currentCompany?.id}
										path="rfx/:rfxId/getsubmission/:submissionCompanyId/:currentTab"
									/>
									<RfqOverview path="/rfx" />
									<RfxSubmissionDataProvider
										path="rfx/:rfxRouteId/submission/:rfxInviteRouteId"
										useParentRfxData={false}
									>
										<RFQPreview path=":currentTab" />
										<RFQPreview path=":currentTab/:contextId" />
										{/* <RFQPreview path="/*" /> */}
									</RfxSubmissionDataProvider>
								</>
							)}
							{/* Existing Route */}
							{/* START OF ACCOUNT SETTING MENU */}
							<Settings
								path="account-settings"
								company={currentCompany}
							/>
							<RfxSettings
								path="rfx-settings"
								company={currentCompany}
							/>
							<EditUserAccount path="edit-user-account" />
							<Invoice
								path="account-settings/invoice"
								company={currentCompany}
							/>
							<CreateUserForm path="account-settings/create-user" />
							<UpdateCreditCard path="account-settings/update-card-details" />

							<EditUserProfile
								path="edit-user-profile"
								company={"My Profile"}
							/>
							{/* END OF ACCOUNT SETTING MENU */}
							<CompanyProfile
								path="company-profile/:activeTab"
								company={currentCompany}
							/>
							<KeyPersonnelFormPage path="company-profile/:activeTab/add" />
							<KeyPersonnelFormPage path="company-profile/:activeTab/:id/edit" />
							<AddProject
								path="company-profile/:activeTab/create-project"
							/>
							<EditProject
								path="company-profile/:activeTab/edit-project/:projectId"
								profileTypeId={currentCompany?.profile_type?.id}
							/>
							<DocumentRequest path="company-profile/:activeTab/request-view" />
							<Search
								path="search/*"
								title="Search"
							/>

							<NotFound default />
						</Router>
					</ContentContainer>
				</Box>
			) : (
				<div style={{ padding: 50, flexGrow: 1 }}>
					<Skeleton
						duration={0.5}
						count={10}
						width="100%"
					/>
				</div>
			)}
		</>
	);
};

const mapStateToProps = () => {
	return {
		loading: false, //removed because same redux state value is used in 2 different component
	};
};

export const Supplier = connect(mapStateToProps, {
	getPastProjects,
	getResources,
	getDocuments,
})(SupplierComponent);
